import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

type MovementControlProps = {
  value: boolean | null;
};

export const MovementControl: React.FC<MovementControlProps> = ({ value }) => {
  const { t } = useTranslation('channel-details');

  const renderMovementContent = () => {
    if (value === true) return <span>{t('exalus.movement.detected')}</span>;
    if (value === false) return <span>{t('exalus.movement.notDetected')}</span>;

    return <span className="sensor-control-box__status">{t('exalus.sensor.noData')}</span>;
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" padding="0 10px">
      {renderMovementContent()}
    </Stack>
  );
};
